import React, { useState } from "react";
import { useSelector } from "react-redux";
import { monthsAllLang } from "../../../../utils/utils";
import Widget from "../../../features/widget/Widget";
import iconsList from "../../../ui/icons/iconsList";
import CalendarWeekDates from "./calendarWeekDates/CalendarWeekDates";
import CalendarWeekEvents from "./calendarWeekEvents/CalendarWeekEvents";
import ScrollLTR from "../../../ui/scrollLTR/ScrollLTR";
import pathRouts from "../../../../enums/pathRoute";
import classes from './CalendarWidget.module.css';

const CalendarWidget = () => {

    const { lang } = useSelector(state => state.translate);
    const [selectedDate, setSelectedDate] = useState(new Date());

    const handleDateSelect = (e, date) => {
        e.preventDefault();
        e.stopPropagation();
        setSelectedDate(date);
    };

    return (
        <Widget
            color="#C5D7E4"
            className={classes.CalendarWidget}
            title={`${monthsAllLang[new Date().getMonth()]?.[lang]} ${new Date().getFullYear()}`}
            icon={iconsList.calendar}
            mainLink={`/${pathRouts.CALENDAR}`} 
            contentScrollable = { false}
                >
                <div className={classes.CalendarWidgetContent}>
                    <CalendarWeekDates
                        selectedDate={selectedDate}
                        onDateSelect={handleDateSelect}
                    />
                    <ScrollLTR height="calc(100% - 52px)" >
                        <CalendarWeekEvents
                            selectedDate={selectedDate}
                        />
                    </ScrollLTR>
                </div>
        </Widget >
    );
};

export default CalendarWidget;
